

<div>

<app-boardlist [listType] = 'feature + "-classList"'> </app-boardlist>

<app-boardlist [listType] = 'feature + "-examList"'> </app-boardlist>

</div>